// Add interface for typed suggestions
export interface RcsSuggestionDto {
    type: string;
    displayText: string;
    suggestionScope: string; // 'global' | 'card'
    cardIndex?: number;
    url?: string;
    phone?: string;
    address?: string;
    latitude?: number;
    longitude?: number;
    startTime?: string;
    endTime?: string;
    meetingTitle?: string;
    meetingDescription?: string;
}

export class RcsMessageDtoRequest {
    id: number;
    folderId: number;
    name: string;
    rcsType: string; // 'text', 'richcard', 'carousel'
    rcsContentJson: string;
    suggestions: RcsSuggestionDto[]; // Array of typed suggestion objects
    smsFallbackEnabled: boolean;
    smsFallbackText: string;
    smsFallbackClientInboxId: number;

    constructor(init: { 
        id: number, 
        folderId: number,
        name: string, 
        rcsType: string,
        rcsContentJson: string,
        suggestions?: RcsSuggestionDto[],
        smsFallbackEnabled: boolean,
        smsFallbackText?: string,
        smsFallbackClientInboxId?: number
    }) {
        this.id = init.id;
        this.folderId = init.folderId;
        this.name = init.name;
        this.rcsType = init.rcsType;
        this.rcsContentJson = init.rcsContentJson;
        this.suggestions = init.suggestions || [];
        this.smsFallbackEnabled = init.smsFallbackEnabled;
        this.smsFallbackText = init.smsFallbackText || '';
        this.smsFallbackClientInboxId = init.smsFallbackClientInboxId || 0;
    }
}